import React from 'react';
import { createRoot } from 'react-dom/client';
import CeeQuarterlyTable from './cee-quarterly-table';

import '../view.css';
import './table.css';

document.addEventListener('DOMContentLoaded', function () {
	const elements = document.querySelectorAll(
		'.gext-cee-quarterly-table-container'
	);
	elements.forEach((element) => {
		const dataElement = element.querySelector('.gext-cee-data');
		if (!dataElement) return;

		const data = JSON.parse(dataElement.textContent || '{}');
		const root = createRoot(element);
		root.render(<CeeQuarterlyTable data={data} />);
	});
});
